<template>
    <div class="electricity">
        <Title firstName="安防监控" lastName="SECURITY AND PROTECTION MONITORING"/>
        <div class="echarts">
            <div class="selectMonitor" >
                <p @click="changeMonitor">
                    {{monitor}}
                    <i class="el-icon-arrow-down"></i>
                </p>
            </div>
            <div id="monitoring" >
                <video autoplay controls class="video" ref="video" width="100%" height="100%"></video>
            </div>

            <div class="list" v-show="showList">
                <SelectList :selectList="monitorList" @tabTitle="tabTitle" keyk="device_id" keyval="device_name"/>
            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
import screenfull from "screenfull"; // 引入全屏显示
const Title = () => import('../../components/title/Title')
const SelectList = () => import('../../components/title/selectList.vue')

import { getVideo } from "../../utils/api/lutaiapi";
let Hls = require('hls.js');
export default {
    data(){
        return {
            isFull:false,
            showList:false,
            monitor:'',
            iframeSrc:'',
            // monitorList:[]
            fullSrc:[require('@/assets/img/fullScreen.png'),require('@/assets/img/full_cancel.png')],
            hls: null,
            url: "http://192.168.192.129:8080/live/maker1.m3u8",
            code:"14174540b53b496383d8983937e2fa34"
        }
    },
    components:{
        Title,SelectList
    },
    computed:{
        monitorList(){
            let list = []
            if(this.$store.state.surveillance.length >0){
                this.$store.state.surveillance.forEach(item => {
                    if(item.rooms.details[0].length > 0){
                        list =  list.concat(item.rooms.details[0])
                    }
                })
            }
            return list
        },
    },
    mounted(){
        let that = this
        // this.fullscreen()
        // setTimeout(function(){
        //     that.getMonitorList()
        // },1000)
        this.getVideos();
    },
    methods:{
        // 全屏显示 
        fullscreen(){
            const element = document.getElementById('monitoring');
            document.getElementById('fullscreen1').addEventListener('click', () => {
                this.isFull = !this.isFull
                if(this.isFull){
                    screenfull.request(element); // 元素全屏
                }else{
                    screenfull.toggle(); // 元素全屏
                }
            });
        },
        changeMonitor(){
            this.showList = !this.showList
        },
        tabTitle(monitor){
            console.log(monitor);
            this.showList = false
            this.monitor = monitor.device_name
            this.iframeSrc =  JSON.parse(monitor.device_details).roomName
        },
        getMonitorList(){
            if(this.monitorList.length >0 ){
                this.monitor = this.monitorList[0].device_name
                this.iframeSrc =  JSON.parse(this.monitorList[0].device_details).roomName
            }
        },
        async getVideos(){
            let obj = {
                cameraIndexCode:this.code,
                type:"hls"
            }
            let response = await getVideo(obj);
            if(response.data.data.video){
                this.url = JSON.parse(response.data.data.video).data.url;
                this.getStream(this.url)
            }
        },
        getStream(source) {
            if (Hls.isSupported()) {
                this.hls = new Hls();
                this.hls.loadSource(source);
                this.hls.attachMedia(this.$refs.video);

                this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
                    console.log("加载成功");
                    this.$refs.video.play();
                });
                this.hls.on(Hls.Events.ERROR, (event, data) => {
                    console.log("加载失败");
                });
            } else if (this.$refs.video.canPlayType('application/vnd.apple.mpegurl')) {
                this.$refs.video.src = 'https://video-dev.github.io/streams/x36xhzz/x36xhzz.m3u8';
                this.$refs.video.addEventListener('loadedmetadata',function() {
                    this.$refs.video.play();
                });
            }
        },
        // 停止流
        videoPause() {
            if (this.hls) {
                this.$refs.video.pause();
                this.hls.destroy();
                this.hls = null;
            }
        }
    }
}
</script>

<style lang="less" scoped>
    .electricity{
        height: 33.3vh;
        width: 20vw;
        position: fixed;
        top: 37.8vh;
        right: 1vw;
        z-index: 1;

        .echarts{
            position: relative;
            height: 25vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);

            .selectMonitor{
                height: 3vh;
                p{
                    position: absolute;
                    right: 1vh;
                    top: 0.7vh;
                    font-size: 14rem;
                    color: #E6F3FD ;
                    cursor: pointer;
                }
            }

            #monitoring{
                height: 21vh;
                position: relative;
                text-align: center;
                background: #000;
                position: relative;
                
                &>.kong{
                    width: 100rem;
                    font-size: 14rem;
                    text-align: center;
                    color: #fff;
                    position: absolute;
                    left:calc(50% - 50rem);
                    top: calc(50% - 50rem);
                    img{
                        width: 80rem;
                        height: 96rem;
                        margin-bottom: 5rem;
                    }
                }
                #fullscreen1{
                    position: absolute;
                    right:0.5vw ;
                    bottom: 1vh;
                    cursor: pointer;
                    color: #E6F3FD;
                    font-size: 20rem;
                    img{
                        width: 2.5vh;
                        height: 2.5vh;
                        vertical-align: middle;
                        margin-right: 5rem;
                    }
                }
            }
            
            .list{
                height: 10.5vh;
                width: 100%;
                position: absolute;
                left: 0;
                top: 3vh;
                z-index: 11;
            }

            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }

        
    }

</style>